import React, { useState, useMemo } from "react";
import { observer } from "mobx-react";
import { Icon } from "@ann/web-components";
import {
  ExpandableContainer,
  ChildrenWrapper,
  ShowMoreButton,
  ShowMoreButtonContainer
} from "./ExpandableChilds.styled";

const ExpandableChilds = observer(({ children, renderChilds = 2 }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  const childrenArray = useMemo(() => {
    return React.Children.toArray(children);
  }, [children]);

  const visibleChildren = isExpanded 
    ? childrenArray 
    : childrenArray.slice(0, renderChilds);

  const hasMoreChildren = childrenArray.length > renderChilds;

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <ExpandableContainer>
      <ChildrenWrapper>
        {visibleChildren}
      </ChildrenWrapper>
      
      {hasMoreChildren && (
        <ShowMoreButtonContainer>
          <ShowMoreButton
            onClick={handleToggle}
            type="button"
            aria-label={isExpanded ? "Mostrar menos" : "Mostrar más"}
          >
            <Icon 
              name={isExpanded ? "chevronUp" : "chevronDown"} 
              color="#666"
              size="16"
            />
          </ShowMoreButton>
        </ShowMoreButtonContainer>
      )}
    </ExpandableContainer>
  );
});

export default ExpandableChilds; 